import { convertPlainUrlToHtml } from "../../utils";

interface Props {
  children: string;
  forbidTags?: string[];
  forbidAttributes?: string[];
  className?: string;
}

export const HTMLRenderer = ({
  children,
  forbidTags = [],
  forbidAttributes = [],
  className,
}: Props) => {
  const rows = children?.split("\n") ?? [];
  const sanitizedRows = rows.map((row) => {
    const htmlTag = row.match(/<.*?>/);
    if (htmlTag) {
      let validTag = htmlTag;
      forbidTags.forEach((forbidTag) => {
        if (!validTag) return;

        const forbidTagRegexp = new RegExp(forbidTag);
        validTag = htmlTag.input.match(forbidTagRegexp) ? null : htmlTag;
      });

      if (!validTag) return;

      let sanitizedTag = htmlTag.input;
      forbidAttributes.forEach((attr) => {
        const attrRegexp = new RegExp(attr + `=['"].*?['"]`);
        sanitizedTag = sanitizedTag.replace(attrRegexp, "");
      });

      return sanitizedTag;
    } else {
      return row;
    }
  });

  const sanitizedHTML = convertPlainUrlToHtml(sanitizedRows.join("\n"));

  return (
    <span
      dangerouslySetInnerHTML={{ __html: sanitizedHTML }}
      tw="w-full inline-block"
      className={className}
    />
  );
};
